/* eslint-disable react/no-unused-prop-types */
import { memo } from 'react';
import {
  Control,
  Controller,
  ControllerRenderProps,
  FieldError,
} from 'react-hook-form';
import NumberFormat, { NumberFormatValues } from 'react-number-format';
import cx from 'classnames';

import { Fields, Names, Rules } from 'types/fields';
import Text from '../text';
import {
  TextFieldError,
  TextFieldInput,
  TextFieldLabel,
  TextFieldWrapper,
} from '../text-field';
import Typography from '../typography';

type TextFieldPhoneProps = {
  control?: Control<any, any>;
  name: Names;
  label?: string;
  error?: FieldError;
  initialValue?: string;
  placeholder?: string;
  largeLabelSize?: boolean;
  disabled?: boolean;
  rules?: Rules;
};

function TextFieldPhone({
  control,
  label,
  name,
  error,
  initialValue,
  placeholder,
  largeLabelSize,
  disabled,
  rules,
}: TextFieldPhoneProps) {
  return (
    <TextFieldWrapper>
      {label && (
        <TextFieldLabel className="outlined-input-label">
          <label htmlFor={name}>
            {largeLabelSize ? (
              <Typography fontWeight="medium">{label}</Typography>
            ) : (
              <Text type="mode2" fw="light">
                {label}
              </Text>
            )}
          </label>
        </TextFieldLabel>
      )}
      <TextFieldInput>
        <Controller
          defaultValue={initialValue}
          control={control}
          rules={rules}
          name={name}
          render={numberController(error, placeholder, disabled)}
        />
      </TextFieldInput>
      <TextFieldError>
        {error?.message && (
          <Text type="mode2" fw="medium">
            {error.message}
          </Text>
        )}
      </TextFieldError>
    </TextFieldWrapper>
  );
}

function numberController(
  error: FieldError | undefined,
  placeholder?: string,
  disabled?: boolean
) {
  return function renderNumberController({
    field: { onChange, name: fieldName, value: fieldValue, onBlur },
  }: RenderNumberControllerProps) {
    function handleValueChange(values: NumberFormatValues) {
      const { value } = values;
      onChange(value);
    }

    return (
      <NumberFormat
        placeholder={placeholder ?? 'Phone Number'}
        format="+1 (###) ###-####"
        mask="_"
        name={fieldName}
        value={fieldValue}
        onValueChange={handleValueChange}
        className={cx({ invalid: Boolean(error) })}
        id={fieldValue}
        onBlur={onBlur}
        disabled={disabled}
      />
    );
  };
}

interface RenderNumberControllerProps {
  field: ControllerRenderProps<Fields>;
}

export default memo(TextFieldPhone);
